module.exports = __webpack_public_path__ + "static/media/5.4e9dcd28.png";